/**
 * ToggleScroll
 * @param disableScroll boolean
 * Disables scrolling when set as true, enables it when set as false
 *
 * @returns
 * Toggles scrolling either by removing or adding overflowY = 'hidden' to the body tag.
 */

const ToggleScroll = (disableScroll: boolean): void => {
    const BODY_ELEMENT = document.querySelector('body');
    if (!BODY_ELEMENT) {
        return;
    }
    if (disableScroll) {
        // only set the style
        if (BODY_ELEMENT.style.overflowY === '') {
            BODY_ELEMENT.style.overflowY = 'hidden';
        }
    } else if (BODY_ELEMENT.style.overflowY === 'hidden') {
        BODY_ELEMENT.style.overflowY = '';
    }
};


export default ToggleScroll;
